﻿
myApp.controller("allprojectsCtrl", ['$scope', '$http', function ($scope, $http) {
    $scope.setPage("projects");//navbar action
    $(".figure").css("opacity", "1");
    $scope.setPageClass("yit-projects-page all-project");

    $scope.AllStrings = {
        projects: {

        },
        cms: {
            btn: "",
            desc: ""
        }
    }

    $scope.WaitForStrings(function () {
        var xml = this.strings;
        var page = $(xml).find("allprojects");
        var home = $(xml).find("home");

        $scope.AllStrings.title = $(page).find("title").find($scope.lang).text().trim();
        $scope.setTitle($scope.AllStrings.title);//set title to the page

        $scope.AllStrings.cms.btn = $(page).find("cms").find("btn").find($scope.lang).text().trim();
        $scope.AllStrings.cms.desc = $(page).find("cms").find("desc").find($scope.lang).text().trim();
        //projects
        var projects = $(page).find("projects").children();

        projects.each(function () {
            var name = $(this).find($scope.lang).text().trim();
            var eng = $(this).find("eng").text().trim().replace(/\s/g, '').replace(/-/g, "");
            $scope.AllStrings.projects[eng] = name;

        });
        console.log($scope.AllStrings.projects)
    }.bind($scope));



}]);



//////////////////
// WEBPACK FOOTER
// ../scripts/yit/pages/allprojects.js
// module id = 19
// module chunks = 0